import React from "react";
import ProgramPages from "../../Components/DashBoard/programNamePage";
function ProgramPage() {
  return <ProgramPages />;
}

export default ProgramPage;
